import React from "react";
import { Switch, Route } from "react-router-dom";

import InspectionMastersPage from "./InspectionMastersPage";
import InspectionsPage from "./InspectionsPage";

const InspectionsRouter = () => (
  <Switch>
    <Route path="/fleet/inspection-masters/inspections/:id">
      <InspectionsPage />
    </Route>
    <Route path="/fleet/inspection-masters">
      <InspectionMastersPage />
    </Route>
  </Switch>
);

export default InspectionsRouter;
